import React from "react";

const CreateTemplate = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M6.8 2v4.8H2V10h4.8v4.8H10V10h4.8V6.8H10V2H6.8ZM18 8.4A9.6 9.6 0 0 1 8.4 18c-1.122 0-2.2-.192-3.2-.546V32.41c0 .877.715 1.589 1.597 1.589H22.8v-9.6c0-.88.72-1.6 1.6-1.6H34V6.798c0-.882-.712-1.598-1.59-1.598H17.455c.354 1 .546 2.078.546 3.2ZM34 26l-8 7.995V26h8Z"
              fill={fill}
        />
    </svg>
);

export default CreateTemplate;